module.exports = __webpack_public_path__ + "static/lauproduction3-59f7fabc8e89a11ef055edd6f311b161.jpg";